import {events} from '../events';

export const termsAndConditionsReducer = {
    [events.TERMS_AND_CONDITIONS_SET]: (state, action) => ({
        ...state,
        ...action.payload
    })
};
